export function SkipLink(props: {label: string, query: string}){
  return <button onClick={(event)=>{
    event.preventDefault();
    event.stopPropagation();
    const shadowRoot = document.getElementById('febis-questionizer')?.shadowRoot;
    const elements = shadowRoot?.querySelectorAll<HTMLElement>(props.query);
    console.log(shadowRoot, elements[0], elements);
    if(elements && elements.length > 0){
      elements[0]?.focus();
    }
  }} role="menuitem" className="skip"><span>{props.label}</span></button>;
}